import { User } from "@/types";

import { axios } from "../axios.instance";

export type ResetPasswordRequest = {
  email: User["email"];
  code: string;
  newPassword: string;
};

export type ResetPasswordResponse = object;

export const resetPassword = async (body: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
  const { data } = await axios.post("auth/reset-password", body);

  return data;
};
